import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import PsychologyIcon from '@mui/icons-material/Psychology';
import { useMatch } from 'react-router-dom';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import CreateIcon from '@mui/icons-material/Create';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';

const OrderSummary = ({
  selectedTime,
  selectedDate,
  meetingDetails,
  title,
  eligibility,
  duration,
  administrations,
  price,
  shareReport
}) => {
  const meeting = useMatch('/therapists/*');
  const selfAssessment = useMatch('/self-assessments/*');

  const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    });
  };
  return (
    <div className="order-summary-container flex-container margin-top--md">
      <div className="order-summary">
        <h4>Order Summary</h4>
        <div className="margin-top--md">
          {meeting ? (
            <p className="detail-item flex-container">
              <EventIcon color="primary" style={{ marginRight: '10px', marginTop: '2px' }} />

              {selectedTime?.startTime && selectedTime?.endTime && selectedDate && (
                <>
                  {formatDate(selectedDate)} at {selectedTime?.startTime} - {selectedTime?.endTime}
                </>
              )}
            </p>
          ) : selfAssessment ? (
            <p className="detail-item flex-container">
              <DescriptionIcon color="primary" style={{ marginRight: '10px', marginTop: '2px' }} />
              {title}
            </p>
          ) : null}
          {meeting ? (
            <p className="detail-item flex-container">
              <PsychologyIcon
                color="primary"
                style={{ transform: 'scaleX(-1)', marginRight: '10px' }}
              />
              {meetingDetails?.service?.title}
              &nbsp;
              <span
                style={{
                  backgroundColor: 'rgb(216 230 253)',
                  padding: '0px 6px',
                  borderRadius: '5px'
                }}>
                {meetingDetails?.service?.duration} min
              </span>
            </p>
          ) : selfAssessment ? (
            <p className="detail-item flex-container">
              <RecommendOutlinedIcon
                color="primary"
                style={{ transform: 'scaleX(-1)', marginRight: '10px' }}
              />
              {eligibility}
            </p>
          ) : null}
          {meeting ? (
            <p className="detail-item flex-container">
              <LocationOnIcon color="primary" style={{ marginRight: '10px' }} />
              {meetingDetails?.location?.location}
            </p>
          ) : selfAssessment ? (
            <p className="detail-item flex-container">
              <HourglassEmptyIcon color="primary" style={{ marginRight: '10px' }} />
              {duration}
            </p>
          ) : null}
          {selfAssessment ? (
            <p className="detail-item flex-container">
              <CreateIcon color="primary" style={{ marginRight: '10px' }} />
              {administrations}
            </p>
          ) : null}
        </div>
        <hr className="margin-top--md" />
        <div className="flex-container justify-between">
          {meeting ? (
            <p style={{ paddingRight: '10px' }}> {meetingDetails?.service?.title}</p>
          ) : selfAssessment ? (
            <p style={{ paddingRight: '10px' }}> Assessment </p>
          ) : null}
          <p style={{ minWidth: '100px', textAlign: 'right' }}>{price} ₹</p>
        </div>
        {selfAssessment && shareReport && (
          <p
            className="flex-container margin-top--sm"
            style={{ maxWidth: '80%', fontSize: '11px', color: ' var(--gray-light)' }}>
            <LockOpenTwoToneIcon
              style={{ color: 'green', marginTop: '-3px', marginRight: '8px', fontSize: '20px' }}
            />
            <span> Report shared with you</span>
          </p>
        )}
        {selfAssessment && !shareReport && (
          <p
            style={{ maxWidth: '80%', fontSize: '11px', color: ' var(--gray-light)' }}
            className="flex-container margin-top--sm">
            <LockIcon
              style={{ color: 'red', marginTop: '-3px', marginRight: '8px', fontSize: '20px' }}
            />
            <span>Report shared with therapist only - not visible to you</span>
          </p>
        )}

        <hr className="margin-top--xl" />

        <div className="flex-container justify-between ">
          <b>Total</b>
          <b style={{ minWidth: '100px', textAlign: 'right' }}>{price} ₹</b>
        </div>
      </div>
      <style jsx>{`
        .order-summary-container {
          max-width: 400px;
          // padding: 0px 20px;
          width: 45%;
        }
        .order-summary {
          background-color: #fff;
          border-radius: 7px;
          border-top: 3px solid #007aff;
          box-shadow: 0 0 3px #dadce0;
          padding: 0px 20px 20px 20px;
          box-sizing: border-box;
          width: 100%;
          max-height: 400px;
        }
        .detail-item {
          // flex-basis: 45%;
          white-space: normal;
          // word-break: break-word;
          margin-top: 10px;
          align-items: start;
        }

        @media only screen and (max-width: 800px) {
          .order-summary-container {
            max-width: 445px;
            order: -1;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default OrderSummary;
